import { render, staticRenderFns } from "./promo.vue?vue&type=template&id=1071013e"
import script from "./promo.vue?vue&type=script&lang=js"
export * from "./promo.vue?vue&type=script&lang=js"
import style0 from "./promo.vue?vue&type=style&index=0&id=1071013e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports